import React from 'react'

export default function PlaybookComponent() {
  return (
    <div>
       <div class="service_area pb-70">
       <div class="section_title text_center mb-70 ">
              
              
        </div> 
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-6 col-md-6 col-sm-12 event d-flex justify-content-center mb-3 mb-md-0">
            <div class="service_style_two mb-4 playbook">
              <div class="service_style_two_number mr-60 w-30">
              <img src='assets/images/playbook.webp' className="img-fluid" alt="playbook"/>
              </div>
           
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="service_style_two mb-4">
           
              <div class="service_style_two_content">
               <div class="service_style_two_number mr-60 w-30">
              <img src='assets/images/playbook.svg' className="img-fluid" alt="Gartner-playbook"/>
              </div>
                <div class="service_style_two_text text-left">
                 
                  <div class="button three past-event mr-300 mt-50">
                <a href="https://7772074d.flowpaper.com/GTMPlaybook/" target="_blank" rel="noopener noreferrer">Get the Playbook</a>
              </div>
                </div>
              </div>
            </div>
          </div>
       
         
      
         
        </div>
      </div>
    </div>
    </div>
  )
}
